import { render } from "./V-dialog-common.vue?vue&type=template&id=5ae82737&scoped=true"
import script from "./V-dialog-common.vue?vue&type=script&lang=js"
export * from "./V-dialog-common.vue?vue&type=script&lang=js"

import "./V-dialog-common.vue?vue&type=style&index=0&id=5ae82737&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae82737"]])

export default __exports__